import { useEffect, useRef, useState } from 'react';
import { useCountUp } from './useCountUp';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/i18n';

const NumberAni: React.FC = () => {
    const { t } = useLang('dpux.NumberAni');
    const { locale = 'us' } = getLocal();

    const [enter, setEnter] = useState(false);
    const sectionRef = useRef<HTMLDivElement>(null);
    const screenRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        let screen;
        if (window.innerWidth >= 1024) {
            screen = AniContainer.create({
                triggerElement: sectionRef.current,
                triggerHook: 0,
                offset: '0%',
                duration: window.innerHeight * 1.1,
                onProcess: (process: number) => {
                    if (process <= 0) {
                        setEnter(false);
                    }
                },
                onEnter: () => {
                    setEnter(true);
                },
            });
        } else {
            screen = AniContainer.create({
                triggerElement: sectionRef.current,
                triggerHook: 1,
                offset: '40%',
                duration: '100%s',
                onProcess: (process: number) => {
                    if (process <= 0) {
                        setEnter(false);
                    }
                },
                onEnter: () => {
                    setEnter(true);
                },
            });
        }

        return () => {
            screen.destroy?.();
        };
    }, []);

    const { curNumber, run, reset } = useCountUp({ number: locale === 'us' ? 6000 : 4000, time: 1200 });
    useEffect(() => {
        if (enter) {
            run();
        } else {
            reset();
        }
    }, [enter]);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-NumberAni GtmModuleData-section`}
            id="delta-pro-ultra-x-NumberAni"
            data-section-id={'delta-pro-ultra-x-NumberAni'}
            data-section-title={t('title')}
            ref={sectionRef}
        >
            <div className={`number-container ${enter ? 'enter' : ''}`} ref={screenRef}>
                <div className="info">
                    <div className="left">
                        <div className="l-top">
                            <span className="text-1">{t('left1')}</span>
                            <span className="text-2">{t('left2')}</span>
                        </div>
                        <div className="l-bottom">{t('left3')}</div>
                    </div>
                    <div className="center">
                        {curNumber.split('').map((i, idx) => (
                            <div key={idx}>{i}</div>
                        ))}
                    </div>
                    <div className="right">{t('right')}</div>
                </div>
            </div>
        </section>
    );
};

export default NumberAni;
